/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    category: PropTypes.bool,
    subitem: PropTypes.bool,
    draggable: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'tr',
    category: false,
    subitem: false,
    draggable: false,
};

const TableRow = (props) => {
    const classNames = [
        'c-table__row',
        props.category ? 'c-table__row--category' : '',
        props.subitem ? 'c-table__row--subitem' : '',
        props.draggable ? 'c-table__row--draggable' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

TableRow.propTypes = propTypes;

TableRow.defaultProps = defaultProps;

export default TableRow;
